/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Secondary_LabelInputs */



/**
* | output |
* | --- |
* | "Secondary" |
*
* @param {Styles_Secondary_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_secondary_label = /** @type {((inputs?: Styles_Secondary_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Secondary_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Secondaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sekundär")
	if (locale === "it") return /** @type {LocalizedString} */ ("Secondario")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вторичный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Secundario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("次要")
	if (locale === "ja") return /** @type {LocalizedString} */ ("二次")
	if (locale === "hi") return /** @type {LocalizedString} */ ("माध्यमिक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Secundário")
	return /** @type {LocalizedString} */ ("Secondary")
});